import React from "react";
import parse from "html-react-parser";
import { Quote } from "lucide-react";

interface TestimonialCardProps {
  image: string;
  id?: number | string;
  message: string;
  name: string;
  position: string;
}

function TestimonialCard({
  image,
  id,
  message,
  name,
  position,
}: TestimonialCardProps) {
  return (
    <div key={id} className="cht-px-3 cht-py-2">
      <div className="cht-rounded-[24px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft cht-p-6 sm:cht-p-10 lg:cht-p-12">
        <div className="cht-grid lg:cht-grid-cols-12 cht-gap-8 lg:cht-gap-12 cht-items-center">
          
          {/* Avatar Showcase (4 cols) */}
          <div className="lg:cht-col-span-4 cht-flex cht-flex-col cht-items-center cht-justify-center">
            <div className="cht-relative cht-w-32 cht-h-32 sm:cht-w-40 sm:cht-h-40 cht-rounded-full cht-p-1.5 cht-bg-gradient-to-tr cht-from-[#3e57da] cht-to-indigo-300 cht-shadow-md">
              <img
                src={image}
                className="cht-w-full cht-h-full cht-rounded-full cht-object-cover cht-border-2 cht-border-white"
                alt={name}
                loading="lazy"
              />
            </div>
          </div>

          {/* Quote & Client Info (8 cols) */}
          <div className="lg:cht-col-span-8 cht-space-y-4 cht-text-center lg:cht-text-left">
            <div className="cht-inline-flex cht-items-center cht-justify-center cht-w-10 cht-h-10 cht-rounded-xl cht-bg-blue-50 cht-text-[#3e57da]">
              <Quote size={20} />
            </div>

            <div className="!cht-font-body cht-text-sm sm:cht-text-base md:cht-text-lg cht-text-slate-700 cht-leading-relaxed cht-italic">
              {parse(`${message}`)}
            </div>

            <div className="cht-pt-2 cht-border-t cht-border-slate-100">
              <h4 className="!cht-font-heading cht-text-base sm:cht-text-lg !cht-font-bold cht-text-slate-900 cht-mb-0.5">
                {name}
              </h4>
              <p className="!cht-font-body cht-text-xs sm:cht-text-sm !cht-font-semibold cht-text-[#3e57da] cht-mb-0">
                {position}
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;

